export enum TimerType {
    elapsed = "elapsed",
    additional = "additional",
    countdown = "countdown",
    countup = "countup",
}
